import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function DirectorNameStep({ formData, setFormData }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.directorName")}</h2>
      <input
              ref={inputRef}
        type="text"
        value={formData.directorName}
        onChange={e =>
          setFormData({ ...formData, directorName: e.target.value })
        }
      />
    </>
  );
}
